import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, getDocs, query, orderBy } from './firestore-compat';
import { ROLES } from './config/permissions';

const AUDITORIA_DESATIVADA = true;

const AuditPermissions = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('');

    useEffect(() => {
        if (AUDITORIA_DESATIVADA) { setLoading(false); return; }
        const fetchUsers = async () => {
            try {
                const q = query(collection(db, 'users'), orderBy('name'));
                const snapshot = await getDocs(q);
                const usersData = snapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setUsers(usersData);
            } catch (error) {
                console.error("Erro ao buscar usuários:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUsers();
    }, []);

    const getRoleLabel = (roleId) => {
        // Tenta mapear, se não achar retorna o ID
        const entry = Object.entries(ROLES).find(([key, val]) => val === roleId);
        return entry ? entry[0] : roleId;
    };

    const filteredUsers = users.filter(user =>
        user.name?.toLowerCase().includes(filter.toLowerCase()) ||
        user.email?.toLowerCase().includes(filter.toLowerCase())
    );

    if (loading) return <div className="p-4">Carregando auditoria...</div>;

    if (AUDITORIA_DESATIVADA) {
        return (
            <div style={{ padding: '80px 20px', textAlign: 'center' }}>
                <div style={{ fontSize: 54, marginBottom: 16 }}>🛠️</div>
                <h3 style={{ color: '#1e293b', marginBottom: 8, fontWeight: 700, fontSize: '1.2rem' }}>Auditoria temporariamente desativada</h3>
                <p style={{ color: '#64748b', fontSize: '0.9rem' }}>Em manutenção. Volta em breve.</p>
            </div>
        );
    }

    return (
        <div className="audit-container" style={{ padding: '20px' }}>
            <h1>Auditoria de Permissões</h1>

            <div className="controls" style={{ marginBottom: '20px' }}>
                <input
                    type="text"
                    placeholder="Filtrar por nome ou email..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    style={{ padding: '8px', width: '300px' }}
                />
                <span style={{ marginLeft: '10px' }}>Total: {filteredUsers.length} usuários</span>
            </div>

            <table className="audit-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
                <thead>
                    <tr style={{ backgroundColor: '#f0f0f0', borderBottom: '2px solid #ccc' }}>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Nome / Email</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Papéis (Roles)</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>Permissões Granulares (Checkboxes)</th>
                        <th style={{ padding: '10px', textAlign: 'left' }}>ID Firestore</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredUsers.map(user => {
                        const roles = Array.isArray(user.roles) ? user.roles : (user.role ? [user.role] : []);
                        const permissions = user.permissions || {};
                        const activePermissions = [];

                        Object.entries(permissions).forEach(([module, perms]) => {
                            if (perms.view) activePermissions.push(`${module}:Ver`);
                            if (perms.edit) activePermissions.push(`${module}:Editar`);
                        });

                        return (
                            <tr key={user.id} style={{ borderBottom: '1px solid #eee' }}>
                                <td style={{ padding: '10px' }}>
                                    <strong>{user.name}</strong><br />
                                    <span style={{ color: '#666', fontSize: '12px' }}>{user.email}</span>
                                </td>
                                <td style={{ padding: '10px' }}>
                                    {roles.length > 0 ? roles.map(r => (
                                        <span key={r} style={{
                                            display: 'inline-block',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            backgroundColor: '#e0f2f1',
                                            color: '#004d40',
                                            marginRight: '4px',
                                            fontSize: '12px'
                                        }}>
                                            {getRoleLabel(r)}
                                        </span>
                                    )) : <span style={{ color: '#999' }}>Sem papéis</span>}
                                </td>
                                <td style={{ padding: '10px' }}>
                                    {activePermissions.length > 0 ? (
                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
                                            {activePermissions.map(p => (
                                                <span key={p} style={{
                                                    padding: '2px 6px',
                                                    borderRadius: '4px',
                                                    backgroundColor: '#e8f5e9',
                                                    color: '#1b5e20',
                                                    fontSize: '11px',
                                                    border: '1px solid #c8e6c9'
                                                }}>
                                                    {p}
                                                </span>
                                            ))}
                                        </div>
                                    ) : <span style={{ color: '#999' }}>Nenhuma granular</span>}
                                </td>
                                <td style={{ padding: '10px', fontFamily: 'monospace', color: '#888', fontSize: '11px' }}>
                                    {user.id}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default AuditPermissions;
